import React from "react";

import { Box } from "@UI/Components/Box/Box";
import { HStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { ICandidate, ICandidateCardProps } from "../../types";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

export const CandidateActions = (
  props: {
    conversationId: number;
    hasUnreadMessages?: boolean;
    hasServiceOffer: boolean;
    isLoading: boolean;
  } & Pick<ICandidate, "offerWithdrawn" | "offerAsked"> &
    ICandidateCardProps
) => {
  const {
    hasUnreadMessages = false,
    offerAsked,
    offerWithdrawn,
    hasServiceOffer,
    isLoading,
  } = props;

  return (
    <HStack spacing="8px">
      {!hasServiceOffer ? (
        <Button
          flex="1"
          variant="outline"
          size="lg"
          borderColor="primary"
          color="primary"
          _disabled={{
            color: "gray.300",
            borderColor: "gray.300",
            cursor: "auto",
          }}
          _hover={{
            borderColor:"seaGreen",
            background: "seaGreen",
            color: "white",
          }}
          isDisabled={
            isLoading || offerWithdrawn || (offerAsked && !hasServiceOffer)
          }
          data-bs-toggle="offcanvas"
          data-bs-target={`#offcanvas-conversation-${props.conversationId}`}
          aria-controls="offcanvasRight"
          onClick={() => {
            // this is trying to find "Ask an offer" button from the legacy conversation modal header and click it.
            // the legacy conversation modal is being opened using `data-bs-toggle="offcanvas"`
            const selectedConversationAskOfferButton = document.querySelector(
              `[data-conversation-id="${props.conversationId}"]`
            );

            if (selectedConversationAskOfferButton instanceof HTMLElement) {
              selectedConversationAskOfferButton.click();
            }
          }}
        >
          <FormattedMessage
            {...messages[
              `serviceRequest.${
                offerWithdrawn
                  ? "offerWithdrawn"
                  : offerAsked
                  ? "offerAsked"
                  : "askAnOffer"
              }`
            ]}
          />
        </Button>
      ) : (
        <Button
          flex="1"
          size="lg"
          colorScheme="seaGreen"
          onClick={() => props.onCandidateOfferModalOpen(props.conversationId)}
        >
          <FormattedMessage {...messages["serviceRequest.seeOffer"]} />
        </Button>
      )}

      <Button
        flex="1"
        size="lg"
        p="15px"
        background="transparent"
        border="1px"
        borderColor="gray.300"
        position="relative"
        _hover={{
          background: "initial",
          color: "gray.800",
          borderColor: "gray.500",
        }}
        data-bs-toggle="offcanvas"
        data-bs-target={`#offcanvas-conversation-${props.conversationId}`}
        aria-controls="offcanvasRight"
        onClick={() =>
          props.removeUnreadIndicatorFromConversation(props.conversationId)
        }
      >
        <Text m="0">
          <FormattedMessage {...messages["serviceRequest.discuss"]} />
        </Text>
        {hasUnreadMessages && (
          <Box
            position="absolute"
            top="-3px"
            right="-3px"
            background="red.500"
            w="12px"
            h="12px"
            borderRadius="50%"
          />
        )}
      </Button>
    </HStack>
  );
};
